import { useState } from 'react';
import { topicTags } from '@/mocks/homeData';

export default function TopicWall() {
  const [active, setActive] = useState<string[]>([]);

  const toggle = (label: string) => {
    setActive((prev) =>
      prev.includes(label) ? prev.filter((item) => item !== label) : [...prev, label],
    );
  };

  return (
    <section id="topics" className="px-4 md:px-8 pt-16 md:pt-28">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.25em] text-primary-600">话题标签墙</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              按标签横向追更
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              每个标签对应一类梳理角度，点选后可组合查看，标签墙会随更新动态增减。
            </p>
          </div>
          <span className="self-start md:self-auto px-4 py-2 text-xs rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
            已选 {active.length} 个标签
          </span>
        </div>

        <div className="mt-8 md:mt-10 flex flex-wrap gap-3">
          {topicTags.map((tag) => {
            const selected = active.includes(tag.label);
            return (
              <button
                key={tag.label}
                type="button"
                onClick={() => toggle(tag.label)}
                className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  selected
                    ? 'border-primary-500 bg-primary-500 text-background-50'
                    : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {tag.hot && !selected && (
                  <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-accent-600" />
                )}
                {tag.hot && selected && (
                  <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-accent-300" />
                )}
                <span>{tag.label}</span>
                <span
                  className={`text-xs ${selected ? 'text-primary-100' : 'text-foreground-400'}`}
                >
                  {tag.count}
                </span>
              </button>
            );
          })}
        </div>

        {active.length > 0 && (
          <div className="mt-6 flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-filter-3-line w-4 h-4 flex items-center justify-center" />
            <span>当前筛选：{active.join(' · ')}</span>
            <button
              type="button"
              onClick={() => setActive([])}
              className="underline cursor-pointer hover:text-primary-600"
            >
              清空
            </button>
          </div>
        )}
      </div>
    </section>
  );
}